import { apiClient } from './apiClient';
import type {
  BooksellerEntitlementConfigAdminDto,
  CreateBooksellerEntitlementConfigDto,
  UpdateBooksellerEntitlementConfigDto,
} from '../types/booksellerEntitlementConfig';

const BASE = '/api/app/bookseller-entitlement-configs';

interface AbpListResponse<T> {
  items: T[];
  totalCount: number;
}

// The LIST endpoint returns WithNavigationPropertiesDto — a wrapper around the
// actual config DTO. We unwrap to return the flat config to callers.
interface BooksellerEntitlementConfigWithNavigationPropertiesDto {
  booksellerEntitlementConfig: BooksellerEntitlementConfigAdminDto;
  bookseller: unknown;
}

export const booksellerEntitlementConfigsService = {
  getFirstByBooksellerId: async (booksellerId: string): Promise<BooksellerEntitlementConfigAdminDto | null> => {
    const { data } = await apiClient.get<AbpListResponse<BooksellerEntitlementConfigWithNavigationPropertiesDto>>(
      BASE,
      { params: { BooksellerId: booksellerId, MaxResultCount: 1, SkipCount: 0 } },
    );
    return data.items[0]?.booksellerEntitlementConfig ?? null;
  },

  create: async (input: CreateBooksellerEntitlementConfigDto): Promise<BooksellerEntitlementConfigAdminDto> => {
    const { data } = await apiClient.post<BooksellerEntitlementConfigAdminDto>(BASE, input);
    return data;
  },

  update: async (id: string, input: UpdateBooksellerEntitlementConfigDto): Promise<BooksellerEntitlementConfigAdminDto> => {
    const { data } = await apiClient.put<BooksellerEntitlementConfigAdminDto>(`${BASE}/${id}`, input);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
